import React from 'react'
import {useCallback, useEffect, useMemo, useState} from "react";
import associateServices from "../../services";
import CasinoListItem from "./item";
import FormButton from "../../components/form-button";
import {debounce} from 'lodash'
import {useTranslation} from "react-i18next";
import Loading from "../../components/loading";
import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import SvgIcon from "../../components/svg-icon";
import stringHelper from "../../helpers/string-helper";
import StyleHelper from "../../helpers/styleHelper";

import SlimSelect from "slim-select";

const ProviderGames = props => {

    const {id} = props
    const {configuration} = useSelector(state => state.globalReducer)
    const {t, i18n} = useTranslation()
    const currentLanguage = i18n.language; // Get the current language

    const [search, setSearch] = useState('')
    const [sortBy, setSortBy] = useState('sort')
    const [direction, setDirection] = useState('desc')
    const [sortByUI, setSortByUI] = useState('popular')
    const [loading, setLoading] = useState(false)

    const [isAppend, setIsAppend] = useState(false)
    const [sortBySelect, setSortBySelect] = useState(null)
    const [total, setTotal] = useState(0)
    const [page, setPage] = useState(1)
    const [data, setData] = useState([])
    const [coloredData, setColoredData] = useState([])
    useEffect(() => {
        setColoredData(data?.map(oo => ({
            ...oo,
            color: oo.color === 'random' ? StyleHelper.getRandomColor() : oo.color
        })))
        setLoading(false)
    }, [data])

    const handleNextPage = () => {
        setIsAppend(true)
        setPage(prevState => prevState + 1)
    }

    useEffect(() => {
        if (id) {

            setLoading(true)
            // const cats = ['slots', type.value]
            associateServices.getProviderGames({
                page,
                limit: 24,
                id,
                sortBy,
                direction
            }).then(handleResponse)
        }

    }, [id, page, sortBy, direction])


    const handleResponse = (res) => {
        isAppend ? setData(prevState => [...prevState || [], ...res?.data?.data || []]) : setData(res?.data?.data)
        setTotal(res?.data?.total)
    }


    const sendRequest = useCallback((name) => {
        setLoading(true)
        associateServices.searchGames({name}).then(res => {
            setData(res?.data || [])
            setLoading(false)
        })
    }, []);

    const debouncedSendRequest = useMemo(() => {
        return debounce(sendRequest, 500);
    }, [sendRequest]);


    const onChange = (e) => {
        setIsAppend(false)
        setSearch(e.target.value);
        debouncedSendRequest(e.target.value);
    }

    useEffect(() => {
        setSortBySelect(new SlimSelect({
            select: '#sortSelect',
            showSearch: false,
            events: {
                afterChange: newVal => setSortByUI(newVal[0].value),
            }
        }))

    }, [])

    useEffect(() => {
        sortBySelect?.setSelected(sortByUI)
    }, [sortBySelect, sortByUI])


    useEffect(() => {
        setPage(1)
        if (sortByUI === 'a-z') {
            setSortBy('name')
            setDirection('asc')
        } else {
            setDirection('desc')
            if (sortByUI === 'popular')
                setSortBy('sort')

            else if (sortByUI === 'recently-added')
                setSortBy('released_at')

            else if (sortByUI === 'z-a')
                setSortBy('name')

            else if (sortByUI === 'random')
                setSortBy('random')


            else if (sortByUI === 'payout')
                setSortBy('payout')


            else if (sortByUI === 'max_multiplier')
                setSortBy('max_multiplier')
        }


    }, [sortByUI])

    const navigate = useNavigate()
    const goBack = () =>
        navigate(stringHelper.getLocalizedPath(currentLanguage, '/providers'))

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <div className="filter">
                        <button className="filter__btn" type="button">
                            <SvgIcon id={'filter'}/>
                            {t('casino.filter')}
                        </button>
                        <div className="filter__search">
                            <div className="search">
                                <input
                                    type="text"
                                    name="search"
                                    className="search__input"
                                    placeholder={t('casino.search')}
                                    value={search}
                                    onChange={onChange}
                                />
                                <button className="search__btn" type="button">
                                    <SvgIcon id={'search'}/>
                                </button>
                            </div>
                        </div>


                        <div className="filter__sort">
                            <span className="filter__label">{t('casino.sort-by')}</span>
                            <select
                                name="sortSelect"
                                id="sortSelect"
                                className="filter__select">

                                <option value={'a-z'}>{t('casino.a-z')}</option>
                                <option value={'z-a'}>{t('casino.z-a')}</option>
                                <option value={'popular'}>{t('casino.popular')}</option>
                                <option value={'recently-added'}>{t('casino.recently-added')}</option>
                                <option value={'random'}>{t('casino.random')}</option>
                                <option value={'payout'}>{t('casino.payout')}</option>
                                <option value={'max_multiplier'}>{t('casino.max_multiplier')}</option>
                            </select>
                        </div>

                        <div className="filter__sort">
                            <FormButton
                                label={t('general.view-all-providers')}
                                loading={false}
                                disabled={false}
                                onClick={goBack}
                                isSmall={true}
                                isClassic={true}
                            />
                        </div>


                        <span className="filter__amount">
                            {t('casino.total-shown', {
                                shown: data?.length,
                                total: total
                            })}
                        </span>
                    </div>
                </div>
            </div>


            <div className="row">
                {
                    data?.length <= 0 && loading ? <Loading/> : coloredData?.map((game, i) => <CasinoListItem
                        passive={game?.blacklist?.includes(configuration.country)}
                        index={i} game={game}
                        key={game.id}/>)
                }
            </div>

            {
                data?.length < total && <div className="row">
                    <div className="col-12">
                        <FormButton
                            label={t('general.load-more')}
                            loading={loading}
                            disabled={loading}
                            onClick={handleNextPage}
                        />
                    </div>
                </div>
            }

        </>

    )

}

export default ProviderGames
